import React from "react"
import DynamicField from "components/UI/DynamicFormField/DynamicField"
import { CategoryEditorFields } from "types/categories"

export const CategoryField = (part: any, fieldname: any, context: any) => {
	const field = CategoryEditorFields.find(f => f.key === fieldname)
	if(field) {
		return <DynamicField item={part} path={"categories"} context={context} autosave={true} field={field} />
	}
}